import {WishlistForm} from "@/components/Wishlist/WishlistForm.tsx";
import {useWishlist} from "@/providers/WishlistProvider.tsx";
import {Headline} from "@telegram-apps/telegram-ui";
import {Wishlist} from "@/api/types.ts";
import {useNavigation} from "@/providers/NavigationProvider.tsx";
import {useTranslation} from "react-i18next";
import {useAuthProfile} from "@/providers/AuthProfileProvider.tsx";

export const EditWishlistPage = () => {
  const { authProfile, setAuthProfile } = useAuthProfile();
  const { wishlist, setWishlist } = useWishlist();
  const { navigateToRoute, navigateBack } = useNavigation();
  const { t } = useTranslation();

  if (!authProfile) {
    throw new Error("EditWishlistPage must be inside the AuthProfileProvider");
  }

  if (!wishlist) {
    throw new Error("EditWishlistPage must be inside the WishlistProvider");
  }

  const onSaved = (wishlist: Wishlist) => {
    setWishlist(wishlist);
    authProfile.wishlistPreviews = authProfile.wishlistPreviews.map(wishlistPreview => {
      if (wishlistPreview.id === wishlist.id) {
        return {...wishlist, wishesCount: wishlistPreview.wishesCount};
      }
      return wishlistPreview;
    });
    setAuthProfile({...authProfile});
    navigateBack(true);
  }

  const onDeleted = () => {
    authProfile.wishlistPreviews = authProfile.wishlistPreviews.filter(wishlistPreview => wishlistPreview.id !== wishlist.id);
    setAuthProfile({...authProfile});
    navigateToRoute(`/main`, true);
  }

  return (
    <div className={"mt-3 pb-10"}>
      <Headline className={"pl-2 text-center"} weight={"2"}>{t('wishlist.action.edit')}</Headline>
      <WishlistForm wishlist={wishlist}
                    onSaved={onSaved}
                    onDeleted={onDeleted}
      />
    </div>
  );
}
